module.exports = __webpack_public_path__ + "static/img/img_famous.a691e92.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img_famous.png
// module id = U+EB
// module chunks = 1